import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';

import { useGame } from '../../context';
import { commitMarker } from '../../redux/actions';

const useStyles = createUseStyles({
  container: {
    border: '1px solid rgba(0, 0, 0, 0.15)',
    borderRadius: 4,
    composes: ['py12', 'px12'],
    marginTop: 12,
  },
  select: {
    '&:disabled': { opacity: 0.25 },
    width: '100%',
  },
});

const RegionSelectComponent = React.memo(({ data, disabled }) => {
  const classes = useStyles();
  const { regions } = useGame();
  const dispatch = useDispatch();

  const selected = data?.region || '';

  const regionSelectHandler = useCallback(
    ({ target }) => {
      const region = target.value;
      const next = { ...data, region };
      if (!next.category) return;
      dispatch(commitMarker(next));
    },
    [data, dispatch]
  );

  return (
    <div className={classes.container}>
      <select
        className={classes.select}
        disabled={disabled}
        value={selected}
        onChange={regionSelectHandler}>
        <option value="" />
        {regions.map(obj => (
          <option key={obj.id} value={obj.id}>
            {obj.label}
          </option>
        ))}
      </select>
    </div>
  );
});

RegionSelectComponent.propTypes = {
  data: PropTypes.shape({
    category: PropTypes.string,
    region: PropTypes.string,
  }).isRequired,
  disabled: PropTypes.bool.isRequired,
};

RegionSelectComponent.displayName = 'RegionSelectComponent';

export default RegionSelectComponent;
